export default __webpack_public_path__ + "static/media/pruthvi.d6b65e12.png";